@if(beginRender){
<section class="page-container" [ngClass]="props.isrouterGap ? 'page-top-gap' : ''">
  @if(layoutType === LayoutType.List){
  <filter-list-container class="page-content" [filterSchema]="dynamicFormArray" [props]="props"
    [DataTableSchema]="DataTableSchema" [dataTransform]="dataTransform">
  </filter-list-container>
  }
  @else if(layoutType === LayoutType.Tab && tabConfig){
    @if(showBreadcrumb){
      <app-breadcrums [breadcrumList]="breadcrumList"></app-breadcrums>
    }
    <app-tabs [isLoading]="isLoading" [props]="props" class="page-content" [tabConfig]="tabConfig"
      [filterSchema]="dynamicFormArray" [title]="label" (tabChange)="onTabChange($event)">
    </app-tabs>
  }
  @else if(layoutType === LayoutType.IntegratedTab){
    @if(showBreadcrumb){
    <app-breadcrums [breadcrumList]="breadcrumList" [tabHeaders]="tabConfig" [onTabChange]="onBreadcrumTabChange"
      [groups]="groups" [selectedGroupIndex]="selectedGroupIndex" [onGroupChange]="onGroupChange" [breadcrumbProps]="breadcrumbProps"></app-breadcrums>
    }
    <div class="page-content integrated-content">
      <ng-container *ngIf="tabConfig && tabConfig.length > 0">
        @for(tab of tabConfig; track idx; let idx = $index){
          @if(visitedTabs.has(idx) && selectedTabIndex === idx){
              @if(tab.component){
                <ng-container *ngComponentOutlet="tab.component; inputs: getTabInputs(idx)"></ng-container>
              } @else {
                <div class="tab-fallback">
                  <p>No content available for tab <strong>{{ tab.label }}</strong>.</p>
                </div>
              }
          }
        }
      </ng-container>
    </div>
  }
  @else if(layoutType === LayoutType.Dashboard){
    @if(showBreadcrumb){
    <app-breadcrums [breadcrumList]="breadcrumList" [tabHeaders]="tabConfig" [onTabChange]="onBreadcrumTabChange"
      [breadcrumbProps]="breadcrumbProps"></app-breadcrums>
    }
    <div class="page-content dashboard-content">
      <ng-container *ngIf="tabConfig && tabConfig.length > 0">
        @for(tab of tabConfig; track idx; let idx = $index){
          @if(visitedTabs.has(idx) && selectedTabIndex === idx){
            @if(tab.component){
              <ng-container *ngComponentOutlet="tab.component; inputs: getTabInputs(idx)"></ng-container>
            }
          }
        }
      </ng-container>
    </div>
  }
</section>
}